import { createSelector } from 'reselect';

const selectShapeLeadProviderState = state => state.system.shapeLeadProvider;

export const selectShapeTokens = createSelector(
  selectShapeLeadProviderState,
  state => state.tokens || [],
);

export const selectShapeTokensLoading = createSelector(
  selectShapeLeadProviderState,
  state => state.tokensLoading,
);

export const selectShapeInboundLeads = createSelector(
  selectShapeLeadProviderState,
  state => state.inboundLeads || null,
);

export const selectShapeInboundLeadsLoading = createSelector(
  selectShapeLeadProviderState,
  state => state.inboundLeadsLoading,
);

export const selectShapeAggregates = createSelector(
  selectShapeLeadProviderState,
  state => state.aggregates || null,
);
